import React from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { dataTableParamsForExcelExport } from "shared/components/table/data/DataTableExport";
import {
  MaybernTableBoxActions,
  MaybernTableBoxActionsProps,
  TableExportButton,
} from "shared/components/table/maybern/MaybernTableBoxActions";

export interface DataTableBoxActionsProps extends MaybernTableBoxActionsProps {
  showExport?: boolean;
}

export const DataTableBoxActions: React.FC<
  React.PropsWithChildren<DataTableBoxActionsProps>
> = ({ showExport = true, children, ...props }) => (
  <MaybernTableBoxActions {...props}>
    {children}
    {showExport && <DataTableExportButton />}
  </MaybernTableBoxActions>
);

const DataTableExportButton: React.FC = () => {
  const { title } = useTableBoxContext();

  return (
    <TableExportButton
      getExportParams={(agGrid) => dataTableParamsForExcelExport(agGrid, title)}
    />
  );
};
